export default __webpack_public_path__ + "static/fitcheck-8466340f161d063d1c0e608f4e1cd26e.png";